import * as React from "react";

const MOBILE_BREAKPOINT = 768;

// Synchronous snapshot so the very first render already knows the correct value.
// This prevents the desktop→mobile branch swap that causes React error #300
// ("Rendered fewer hooks than expected") on mobile devices.
function getSnapshot(): boolean {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

function getServerSnapshot(): boolean {
  return false;
}

function subscribe(callback: () => void): () => void {
  const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
  // Also listen to resize for browsers that don't fire matchMedia change reliably
  mql.addEventListener("change", callback);
  window.addEventListener("resize", callback);
  return () => {
    mql.removeEventListener("change", callback);
    window.removeEventListener("resize", callback);
  };
}

export function useIsMobile(): boolean {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
